<template>
    <Collapse v-model:activeKey="data.activeKey" :destroyInactivePanel="true">
        <CollapsePanel :header="$t('components.changeLog.title')">
            <ChangeLog v-bind="props"></ChangeLog>
        </CollapsePanel>
    </Collapse>
</template>

<script>
import { defineAsyncComponent, defineComponent, reactive, watch } from "vue";
import { Collapse } from "ant-design-vue";
import { useRoute } from "vue-router";

export default defineComponent({
    components: {
        Collapse,
        CollapsePanel: Collapse.Panel,
        ChangeLog: defineAsyncComponent(() => import("./ChangeLog")),
    },
    props: {
        id: {},
        onCallChangeLog: {},
        mappings: {},
    },
    setup(props) {
        const route = useRoute();
        const data = reactive({ activeKey: null });
        watch(
            () => route.path,
            () => (data.activeKey = null),
            { flush: "post" }
        );
        return { props, data };
    },
});
</script>
